function NotFound() {
  return (
    <div style={{ padding: "2rem" }}>
      <h2>404 - Course Not Found</h2>
    </div>
  );
}

export default NotFound;
